import { createStyles } from '@mui/styles';
import { APTheme } from '../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
    "@keyframes onloadup": {
        "0%": {
            opacity: 0,
            transform: "translateY(65px)"
        },
        "100%": {
            opacity: 1,
            transform: "translateY(0)"
        }
    },
    termsAndConditionsContainer: {
        maxWidth: 682,
        margin: '9em auto 4em',
        padding: '0 1.5em',
        animationName: `$onloadup`,
        animationDuration: '0.3s',
        animationFillMode: 'both',
        animationTimingFunction: 'cubic-bezier(0.680, -0.550, 0.265, 1.550) both',
        '@media(max-width: 768px)': {
            margin: '6em auto 4em',
        },
        '@media(max-width: 480px)': {
            margin: '4em auto 4em',
        }
    },
    title: {
        maxWidth: 682,
        color: '#4a4a4a',
        marginBottom: 40,
        '@media(max-width: 768px)': {
            textAlign: 'center',
            margin: '0 auto 40px'
        },
        '& > h1': {
            fontSize: 26,
            lineHeight: '34px',
            letterSpacing: '-0.5px',
            margin: '0 0 10px 0',
            fontWeight: 600,
            [theme.breakpoints.down('sm')]: {
                fontSize: '2.0rem',
            },
        },
        '& > p': {
            fontSize: 16,
            lineHeight: '24px',
            letterSpacing: '0',
            margin: 0,
            [theme.breakpoints.down('sm')]: {
                fontSize: '1.4rem',
                lineHeight: 1.45
            },
        }
    },
    section:{
        padding: '30px',
        position: 'relative',
        background: '#FFFFFF',
        boxShadow: '0 1px 4px 0 rgb(0 0 0 / 8%)',
        margin: '0 0 40px 0',
        '& > h2': {
            color: '#4a4a4a',
            fontSize: 20,
            lineHeight: '34px',
            letterSpacing: '-0.5px',
            margin: '0 0 10px 0',
            fontWeight: 600,
        },
        '& h4': {
            fontSize: 16,
            color: '#4a4a4a',
            lineHeight: '34px',
            letterSpacing: '-0.5px',
            margin: '0 0 10px 0',
            fontWeight: 600,
        }
    },
    innerSection:{
        padding: '1em',
        background: 'whitesmoke',
        borderRadius: '5px'
    },
    scrollableInner: {
        height: '40em',
         '& > p': {
            fontSize: 14,
            lineHeight: '24px',
            letterSpacing: '0',
            marginBottom: 10,
            [theme.breakpoints.down('sm')]: {
                fontSize: '1.4rem',
                lineHeight: 1.45
            },
        }
    },
    checkboxWrapper: {
        display: 'flex',
        marginTop: '20px',
        justifyContent: 'center',
        '& .MuiSvgIcon-root': {
            height: '26px',
            width: '26px',
            marginRight: 0
        },
        '& span': {
            fontWeight: 500,
            color: '#4a4a4a'
        },
        '& .MuiFormControlLabel-root': {
            margin: 0
        }
    },
    buttonWrapper: {
        display: 'flex',
        marginTop: '25px',
        justifyContent: 'center'
    },
    continueButton: {
        width: "200px",
        [theme.breakpoints.down('md')]: {
          width: "100%",
        },
    },
    choosePasswordContainer: {
        maxWidth: 542,
        margin: '9em auto 4em',
        padding: '0 1.5em',
        animationName: `$onloadup`,
        animationDuration: '0.3s',
        animationFillMode: 'both',
        animationTimingFunction: 'cubic-bezier(0.680, -0.550, 0.265, 1.550) both',
        '@media(max-width: 768px)': {
            margin: '6em auto 4em',
        },
        '@media(max-width: 480px)': {
            margin: '4em auto 4em',
        }
    },
    loaderWrapper: {
        top: '180px',
        position: 'absolute',
        right: 0,
        left: 0
    }
});
